import { connect } from 'react-redux';
import {
  requestProductDetail,
  requestCreateProductOffers,
  createSavingGoal,
  requestPaymentSchedule,
} from 'src/redux/actions';
import OneTimeTransactionsSuccess from './oneTimeTransactionsSuccess';

function mapStateToProps(state) {
  return {
    productDetail: state.product.productDetail,
    credentials: state.credentials,
    checkout: state.checkout,
    savingPlan: state.savingPlan,
    savingGoals: state.savingGoals,
  };
}

export default connect(mapStateToProps, {
  requestProductDetail,
  requestCreateProductOffers,
  createSavingGoal,
  requestPaymentSchedule,
})(OneTimeTransactionsSuccess);
